const styles = theme => ({
    item: { padding: 3 },
    paper: {
        overflow: "visible",
        textAlign: "center",
        width: "24%"
    },

    content: {
        transform: "translate(0,-40px)",
        height: "auto"
    },

    cardTop: {
        position: "relative",
        width: "100%" - 24,
        margin: 0,
        marginLeft: 12,
        marginRight: 12,
        color: "#fff",
        borderRadius: 6,
        padding: 24,
        textAlign: "center",
        maxHeight: 157
    },
    icon: {
        width: "auto",
        height: 80
    },

    colRed: {
        backgroundColor: "#d12121",
        boxShadow:
            "0 1px 1px rgba(209,33,33,0.15), 0 10px 0 -5px rgba(209,33,33,0.15), 0 10px 1px -4px rgba(209,33,33,0.15), 0 20px 0 -10px rgba(209,33,33,0.15), 0 20px 1px -9px rgba(209,33,33,0.15)"
    },
    colBlue: {
        backgroundColor: "#056dc5",
        boxShadow:
            "0 1px 1px rgba(5,109,197,0.15), 0 10px 0 -5px rgba(5,109,197,0.15), 0 10px 1px -4px rgba(5,109,197,0.15), 0 20px 0 -10px rgba(5,109,197,0.15), 0 20px 1px -9px rgba(5,109,197,0.15)"
    },
    colGreen: {
        backgroundColor: "#00e700",
        boxShadow:
            "0 1px 1px rgba(116,204,13,0.15), 0 10px 0 -5px rgba(116,204,13,0.15), 0 10px 1px -4px rgba(116,204,13,0.15), 0 20px 0 -10px rgba(116,204,13,0.15), 0 20px 1px -9px rgba(116,204,13,0.15)"
    },
    colLightGreen: {
        backgroundColor: "#ddd72c",
        boxShadow:
            "0 1px 1px rgba(221, 215, 44, 0.15), 0 10px 0 -5px rgba(221, 215, 44, 0.15), 0 10px 1px -4px rgba(221, 215, 44, 0.15), 0 20px 0 -10px rgba(116,204,13,0.15), 0 20px 1px -9px rgba(221, 215, 44,0.15)"
    },
    colOrange: {
        backgroundColor: "#ff8c00",
        boxShadow:
            "0 1px 1px rgba(209,103,33,0.15), 0 10px 0 -5px rgba(209,103,33,0.15), 0 10px 1px -4px rgba(209,103,33,0.15), 0 20px 0 -10px rgba(209,103,33,0.15), 0 20px 1px -9px rgba(209,103,33,0.15)"
    }
});

export default styles;
